import {
	getNextPage,
	pageParams,
	retrieveFromStorage,
	saveToStorage,
	sortArray,
} from "../../Components/Functions";
import Api from "../../Server/Api";
import { USER_AUTHENTICATION_DATA } from "../User/types";
import { UPDATE, UPDATE_CURRENT_CHAT } from "./types";

const api = new Api();

const { user } = retrieveFromStorage(USER_AUTHENTICATION_DATA) || {};
const loggedUser = user||{};

export const updateChatList = (data = {}, callback) => {
	return async (dispatch) => {
		dispatch({ ...data, type: UPDATE, loading: true });
		const res = await api.get({ endpoint: `chats/chat_list/` });
		// let first = null;
		// const patientId = new URL(window.location).searchParams.get("patient")
		// let chatview = {}
		// if (res?.length > 0) {
		// 	first = res[0];
		// 	if(patientId){
		// 		first = res.find(e => e.username === patientId);
		// 		if(!first) first = await api.get({ endpoint: `users/${patientId}/short_profile/` });
		// 	}
		// }else{
		// 	if(patientId){
		// 		first = res.find(e => e.username === patientId);
		// 		if(!first) first = await api.get({ endpoint: `users/${patientId}/short_profile/` });
		// 	}
		// }

		// if(first){
		// 	chatview = await api.get({
		// 		endpoint: `chats/${first?.username}/chat_history/`,
		// 	});
		// 	if(chatview?.results){
		// 		chatview.results = sortArray(chatview.results, "id")
		// 	}
		// }

		dispatch({
			...data,
			chatlist: [...res],
			// chatview: { ...chatview, user: first },
			type: UPDATE,
			loading: false,
		});
		if(res?.length > 0){
			callback && callback(res);
		}
	};
};

export const updateChatHistory = (data = {}, username) => {
	

	return async (dispatch) => {
		const _chatviewId = `${loggedUser?.username}-${username}`;
		let page =  _chatviewId === data?.chatviewId ? getNextPage(data) : null;
		if(!page || (page > 1 && data?.count > data?.results?.length)){
			dispatch({ ...data, type: UPDATE_CURRENT_CHAT, loading: true });
			let res = await api.get({ endpoint: `chats/${username}/chat_history/`, data: { page: page || 1 } });
			const _pageData = pageParams(res);
			if (res?.results) {
				const chatviewId = `${loggedUser?.username}-${username}`;
				if (_chatviewId === data?.chatviewId) {
					res.results = sortArray([...res?.results, ...(data?.results||[])].filter(
						(v, i, a) => a.findIndex((t) => t.id === v.id) === i,
						), "id", false);
				}else{
					res.results = sortArray([...res?.results].filter(
						(v, i, a) => a.findIndex((t) => t.id === v.id) === i,
						), "id", false);
				}

				let user = data?.user;
				if(!data?.user){
					user =  await api.get({ endpoint: `users/${username}/short_profile/` });
				}

				dispatch({
					...data,
					...res, 
					user ,
					..._pageData,
					type: UPDATE_CURRENT_CHAT,
					loading: false,
					chatviewId
				});
			}
		}
	};
};

export const updateChatView = (data = {}) => {
	return { ...data, type: UPDATE };
};

export const updateChatHistoryView = (data = {}) => {
	return { ...data, type: UPDATE_CURRENT_CHAT };
};
